import React, { useState, useMemo } from 'react';
import { Machine, MachineStatus, GlobalKPIs } from '../types';
import MachineCard from './MachineCard';

interface Props {
  machines: Machine[];
  kpis: GlobalKPIs;
  lastUpdate: Date;
}

type Filter = 'all' | MachineStatus;

const FILTERS: { key: Filter; label: string; color: string }[] = [
  { key: 'all',         label: 'Todas',      color: '#60a5fa' },
  { key: 'active',      label: 'Ativas',     color: '#10b981' },
  { key: 'idle',        label: 'Ociosas',    color: '#f59e0b' },
  { key: 'maintenance', label: 'Manutenção', color: '#8b5cf6' },
  { key: 'offline',     label: 'Offline',    color: '#ef4444' },
];

export default function Dashboard({ machines, lastUpdate }: Props) {
  const [filter, setFilter] = useState<Filter>('all');

  const filtered = useMemo(
    () => filter === 'all' ? machines : machines.filter(m => m.status === filter),
    [machines, filter],
  );

  const counts = useMemo(() => ({
    all: machines.length,
    active: machines.filter(m => m.status === 'active').length,
    idle: machines.filter(m => m.status === 'idle').length,
    maintenance: machines.filter(m => m.status === 'maintenance').length,
    offline: machines.filter(m => m.status === 'offline').length,
  }), [machines]);

  const updatedAt = lastUpdate.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  return (
    <>
      {/* Toolbar */}
      <div className="toolbar">
        <div className="toolbar-left">
          {FILTERS.map(f => (
            <button
              key={f.key}
              className={`filter-btn ${filter === f.key ? 'active' : ''}`}
              onClick={() => setFilter(f.key)}
            >
              <span className="filter-dot" style={{ background: f.color }} />
              {f.label}
              <span style={{
                marginLeft: 4, fontSize: 10, fontWeight: 700,
                padding: '1px 6px', borderRadius: 100,
                background: filter === f.key ? 'rgba(59,130,246,0.2)' : 'rgba(255,255,255,0.05)',
                color: filter === f.key ? '#60a5fa' : 'var(--text-muted)',
              }}>
                {counts[f.key]}
              </span>
            </button>
          ))}
        </div>
        <span className="toolbar-label">Atualizado: {updatedAt}</span>
      </div>

      {/* Grid */}
      <main className="main-content">
        {filtered.length === 0 ? (
          <p style={{ color: 'var(--text-muted)', padding: '40px 0', textAlign: 'center' }}>
            Nenhuma máquina com esse status.
          </p>
        ) : (
          <div className="machines-grid">
            {filtered.map(m => <MachineCard key={m.id} machine={m} />)}
          </div>
        )}
      </main>
    </>
  );
}
